import moment from "moment";
// All months since 2020
export const months = Array.from({
    length: moment().diff(moment("2020-01-01"), "months") + 1
}, (_, i)=>moment("2020-01-01").add(i, "months").format("YYYY-MM-01"));
